import React, { SVGProps } from 'react';

export const IconTV = (props: SVGProps<SVGSVGElement>) => <svg fill="none" viewBox="0 0 32 32" width="1em" height="1em" {...props}><path fill="currentColor" fillRule="evenodd" d="M2 7.5v17c0 .28.22.5.5.5h27a.5.5 0 0 0 .5-.5v-17a.5.5 0 0 0-.5-.5h-27a.5.5 0 0 0-.5.5ZM4 9v13h24V9H4Zm11.5 14a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1Z" clipRule="evenodd"/></svg>;
